<template>
  <v-form v-model="valid" ref="mainForm">
    <adresse-personnelle :carteAffaire="sas.adressePersonnelle" two-columns></adresse-personnelle>

    <opq-date-picker
      code="date-de-naissance"
      is-birthdate
      v-model="sasEquivalence.dateDeNaissance"
      :live="liveSasEquivalence(3809)"
    ></opq-date-picker>
    <opq-file code="preuve-admissibilite" :live="liveSasEquivalence(3815)" :file="sasEquivalence.preuveDIdentite"></opq-file>

    <opq-catalogue code="profession-psychologue" v-model="sasEquivalence.professionPsychologue" :live="liveSasEquivalence(3802)"> </opq-catalogue>

    <opq-catalogue
      :opq-if="estOui(sasEquivalence.professionPsychologue)"
      code="pays-psychologue"
      v-model="sasEquivalence.paysPsychologue"
      :live="liveSasEquivalence(3803)"
      order-by="text"
    >
    </opq-catalogue>
    <opq-catalogue
      :opq-if="estOui(sasEquivalence.professionPsychologue)"
      code="organisme-psychologue"
      v-model="sasEquivalence.organismePsychologue"
      :live="liveSasEquivalence(3804)"
    >
    </opq-catalogue>

    <opq-text-field
      :opq-if="estOui(sasEquivalence.organismePsychologue)"
      code="nom-organisme-psychologue"
      v-model="sasEquivalence.nomOrganismePsychologue"
      :live="liveSasEquivalence(3805)"
    ></opq-text-field>
    <opq-catalogue
      :opq-if="estOui(sasEquivalence.organismePsychologue)"
      code="autorisation-organisme-psychologue"
      v-model="sasEquivalence.autorisationOrganismePsychologue"
      :live="liveSasEquivalence(3806)"
    >
    </opq-catalogue>
    <opq-text-field
      :opq-if="estOui(sasEquivalence.autorisationOrganismePsychologue)"
      code="numero-organisme-psychologue"
      v-model="sasEquivalence.numeroOrganismePsychologue"
      :live="liveSasEquivalence(3807)"
    ></opq-text-field>
    <opq-memo
      :opq-if="estNon(sasEquivalence.autorisationOrganismePsychologue)"
      code="motif-autorisation-organisme-psychologue"
      v-model="sasEquivalence.motifOrganismePsychologue"
      :live="liveSasEquivalence(3808)"
    ></opq-memo>

    <opq-catalogue
      code="secteur-pratique-1"
      v-model="sasEquivalence.secteurPratique1"
      :live="liveSasEquivalence(3810)"
      :filter="(fd) => fd.value != sasEquivalence.secteurPratique2"
    >
    </opq-catalogue>
    <opq-catalogue
      code="secteur-pratique-2"
      v-model="sasEquivalence.secteurPratique2"
      :live="liveSasEquivalence(3811)"
      optional
      :filter="(fd) => fd.value != sasEquivalence.secteurPratique1"
    >
    </opq-catalogue>
  </v-form>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import FormSimple from "@/mixins/FormSimple"
import AdressePersonnelle from "@/components/FormParts/AdressePersonnelle"
export default {
  mixins: [CataloguesHelper, FormSimple],
  components: { AdressePersonnelle },
  props: {
    sas: { type: Object }
  },

  methods: {
    liveSasEquivalence(cle) {
      return { endpoint: "sas-permis-psychologue-equivalence", cle: cle, fileId: this.sasEquivalence.id }
    }
  },

  computed: {
    sasEquivalence() {
      return this.sas.sasEquivalence
    }
  }
}
</script>

<style>
</style>